// extracted by mini-css-extract-plugin
module.exports = {"highlighter":"markdown-html-highlighter_highlighter__kBUp5"};